export default function (obj: any): void {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '' || obj[propName] === 'null') {
      delete obj[propName]
    }
  }
}
